<template>
  <div>
    <header-component />
    <div class="px-4 py-4">

      <div class="flex justify-between items-center mb-5">
        <h2 class="text-lg font-bold text-gray-800">User Branch Assignment</h2>
      </div>

      <div class="flex flex-wrap gap-3 mb-4">
        <div>
          <label class="block text-xs text-gray-500 mb-1">Search Staff</label>
          <input v-model="search" @input="onSearch" type="text" placeholder="Name..."
            class="border border-gray-300 rounded px-3 py-2 text-sm" style="width:220px" />
        </div>
      </div>

      <div v-if="loading" class="flex justify-center py-12">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
      </div>

      <div v-else class="overflow-x-auto">
        <table class="min-w-full bg-white border border-gray-200 rounded-lg">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Phone</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase w-56">Branch</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="users.length === 0">
              <td colspan="4" class="text-center py-12 text-gray-400">No staff users found.</td>
            </tr>
            <tr v-for="user in users" :key="user.user_id" class="border-b hover:bg-gray-50">
              <td class="px-4 py-3 text-sm text-gray-800">{{ user.name }}</td>
              <td class="px-4 py-3 text-sm text-gray-500">{{ user.phone }}</td>
              <td class="px-4 py-3 text-sm text-gray-500">{{ user.role_label }}</td>
              <td class="px-4 py-3">
                <select
                  :value="user.current_branch_id || ''"
                  @change="assignBranch(user, $event.target.value)"
                  class="border border-gray-300 rounded px-2 py-1 text-sm w-full"
                  :disabled="savingUserId === user.user_id">
                  <option value="">— Unassigned —</option>
                  <option v-for="b in branches" :key="b.id" :value="b.id">{{ b.name }}</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="text-xs text-gray-400 mt-2">
          Users assigned to a branch can accept transfers sent to that branch.
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import Api from "@/middleware/api";
import endpoints from "@/utils/constants";

var BASE = endpoints.LARAVEL_BASE_URL;
var searchTimer = null;

export default {
  name: "UserBranchAssignment",
  data() {
    return {
      users: [],
      branches: [],
      search: "",
      loading: false,
      savingUserId: null,
    };
  },
  created() {
    this.fetchBranches();
    this.fetchUsers();
  },
  methods: {
    async fetchBranches() {
      try {
        var res = await new Api().call("get", BASE + "/api/v1/branches");
        this.branches = res.data.data || res.data;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchUsers() {
      this.loading = true;
      try {
        var params = this.search ? "?search=" + encodeURIComponent(this.search) : "";
        var res = await new Api().call("get", BASE + "/api/v1/staff-users" + params);
        this.users = res.data.users;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    onSearch() {
      clearTimeout(searchTimer);
      var self = this;
      searchTimer = setTimeout(function() { self.fetchUsers(); }, 300);
    },

    async assignBranch(user, branchId) {
      this.savingUserId = user.user_id;
      try {
        await new Api().call("patch", BASE + "/api/v1/users/" + user.user_id + "/branch", {
          branch_id: branchId || null,
        });
        user.current_branch_id = branchId || null;
        var branch = this.branches.find(function(b) { return b.id === branchId; });
        user.branch_name = branch ? branch.name : null;
        window.notify({ message: "Branch updated for " + user.name, type: "success", title: "Saved" });
      } catch (e) {
        var msg = (e && e.response && e.response.data && e.response.data.message) || "Failed to update branch";
        window.notify({ message: msg, type: "danger", title: "Error" });
      } finally {
        this.savingUserId = null;
      }
    },
  },
};
</script>
